//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import visaLogo from '~/assets/Visa.svg';
import amexLogo from '~/assets/Amex.svg';
import discoverLogo from '~/assets/Discover.svg';
import mastercardLogo from '~/assets/Mastercard.svg';
import applePayLogo from '~/assets/ApplePay.svg';
import affirmLogo from '~/assets/Affirm.svg';

export default {
  name: 'PaymentOptions',
  computed: {
    logos() {
      return {
        applePay: applePayLogo,
        visa: visaLogo,
        mastercard: mastercardLogo,
        amex: amexLogo,
        discover: discoverLogo,
        affirm: affirmLogo,
      };
    },
  },
};
